(function () {
  class ScrollContainer extends PIXI.Container {
    constructor() {
      super();

      this._initialised = false;
      this.visible = false;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));

      // Reflex.registerEventHandler('ready', this.onReady.bind(this));
      // messageBus.subscribe('spinner:GameConfigEvent', this.onReady.bind(this));
    }

    createExtraAssets() {
      if (gdk.isSocial() === false) {
        this.bonusBuyEmitter = particleManager.createEmitter(
          'panelSparkleEmitter',
          'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:buyABonusInfoPage:buyABonusSprite',
          0,
          0,
          false
        );
        this.bonusBuyEmitter.particleEmitter.emit = false;
      }

      this.redPigSpine = resourceManager.createObject(
        'spine',
        'redPigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:redFreeSpins',
        {
          name: 'RedPig',
          scaleX: 0.1,
          scaleY: 0.1,
          x: -125,
          y: 150,
        }
      );
      this.redPigSpine2 = resourceManager.createObject(
        'spine',
        'redPigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:combinationFeatures',
        {
          name: 'RedPig',
          scaleX: 0.08,
          scaleY: 0.08,
          x: 0,
          y: 190,
        }
      );
      this.redCoinAnim = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:redFreeSpins:redCoin'
      );
      this.redCoinAnim.gotoAndStop(0);

      this.greenPigSpine = resourceManager.createObject(
        'spine',
        'greenPigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:greenFreeSpins',
        {
          name: 'GreenPig',
          scaleX: 0.1,
          scaleY: 0.1,
          x: -125,
          y: 150,
        }
      );
      this.greenPigSpine2 = resourceManager.createObject(
        'spine',
        'greenPigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:combinationFeatures',
        {
          name: 'GreenPig',
          scaleX: 0.08,
          scaleY: 0.08,
          x: -170,
          y: 190,
        }
      );
      this.greenCoinAnim = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:greenFreeSpins:greenCoin'
      );
      this.greenCoinAnim.gotoAndStop(0);

      this.bluePigSpine = resourceManager.createObject(
        'spine',
        'bluePigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:blueFreeSpinsPt1',
        {
          name: 'BluePig',
          scaleX: -0.1,
          scaleY: 0.1,
          x: -125,
          y: 150,
        }
      );
      this.bluePigSpine2 = resourceManager.createObject(
        'spine',
        'bluePigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:combinationFeatures',
        {
          name: 'BluePig',
          scaleX: -0.08,
          scaleY: 0.08,
          x: 170,
          y: 190,
        }
      );
      this.blueCoinAnim = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:blueFreeSpinsPt1:blueCoin'
      );
      this.blueCoinAnim.gotoAndStop(0);

      this.goldPigSpine = resourceManager.createObject(
        'spine',
        'goldPigSpine',
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:goldWheel',
        {
          name: 'GoldPig',
          scaleX: -0.1,
          scaleY: 0.1,
          x: -125,
          y: 220,
        }
      );
      this.goldCoinAnim = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:goldWheel:goldCoin'
      );
      this.goldCoinAnim.gotoAndStop(0);

      this.pigSpines = [
        this.redPigSpine,
        this.redPigSpine2,
        this.greenPigSpine,
        this.greenPigSpine2,
        this.bluePigSpine,
        this.bluePigSpine2,
        this.goldPigSpine,
      ];
    }

    startAnimations() {
      for (let i = 0; i < this.pigSpines.length; i++) {
        const delay = i * 100;
        timerManager.addTimeout(delay, () => {
          this.pigSpines[i].play('Idle2', true, 0);
        });
      }

      this.redCoinAnim.gotoAndPlay(0);
      this.greenCoinAnim.gotoAndPlay(0);
      this.blueCoinAnim.gotoAndPlay(0);
      this.goldCoinAnim.gotoAndPlay(0);

      if (this.bonusBuyEmitter) {
        this.bonusBuyEmitter.particleEmitter.emit = true;
      }
    }

    stopAnimations() {
      for (let i = 0; i < this.pigSpines.length; i++) {
        this.pigSpines[i].stop();
      }

      this.redCoinAnim.gotoAndStop(0);
      this.greenCoinAnim.gotoAndStop(0);
      this.blueCoinAnim.gotoAndStop(0);
      this.goldCoinAnim.gotoAndStop(0);

      if (this.bonusBuyEmitter) {
        this.bonusBuyEmitter.particleEmitter.emit = false;
      }
    }

    initialise() {
      //Scroll Bar: Regular, Hover, Pressed
      this.tints = [0xffffff, 0xc5d1d6, 0x6d94a6];

      //Scroll Background
      this.backgroundColour = 0x2d2d36;

      //Vertical size of all content to be shown
      this.allContentHeight = 0;

      //Stuff that might not appear
      this.itemContainers = [];
      this.itemPositions = [];

      if (gdk.isSocial() === true) {
        const buyABonusImage1 = resourceManager.get(
          'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:buyABonusInfoPage:buyABonusSprite'
        );
        const buyABonusText1 = resourceManager.get(
          'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:buyABonusInfoPage:bonusBuyText'
        );
        buyABonusText1.y -= buyABonusImage1.height * 0.85; // because asset is over sized!
        buyABonusImage1.parent.removeChild(buyABonusImage1);

        const goldenBetImage = resourceManager.get(
          'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:goldenBet:goldenBetSprite'
        );
        const goldenBetText1 = resourceManager.get(
          'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:goldenBet:goldenBetText'
        );
        goldenBetText1.y -= goldenBetImage.height * 0.7; // because asset is over sized!
        goldenBetImage.parent.removeChild(goldenBetImage);
      }

      this.createExtraAssets();

      const gapBetweenChildren = 50;
      this.addItems(
        resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer'),
        gapBetweenChildren
      );

      this.allContentHeight -= this.amountRemove;

      //Sizes of actual scroll window
      this.scrollMax = 1280;
      this.scrollMin = 720;

      //Scrollbar width & height, radius is how round the top/bottom is
      this.scrollBarTotalHeight = 600;
      this.scrollBarWidth = 12;
      this.scrollBarRadius = 6;

      this.scrollBarHeight = (this.scrollMin / this.allContentHeight) * this.scrollBarTotalHeight;
      this.maxScrollBar = this.scrollBarTotalHeight - this.scrollBarHeight;

      this.scrollProgress = 0;

      this.scrollContainer = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer');

      this.mask = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollArea:scrollMask');
      this.mask.beginFill(0xffffff).drawRect(0, 0, 1, 1).endFill();

      this.mask.width = this.scrollMax;
      this.mask.height = this.scrollMin;
      this.scrollContainer.mask = this.mask;

      this.scrollBarBackground = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollBarContainer:scrollBarBackground'
      );
      this.scrollBarBackground.beginFill(this.backgroundColour);
      this.scrollBarBackground.drawRoundedRect(
        0,
        0,
        this.scrollBarWidth,
        this.scrollBarTotalHeight,
        this.scrollBarRadius
      );
      this.scrollBarBackground.endFill();

      this.scrollBar = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollBarContainer:scrollBar');
      this.scrollBar.beginFill(this.tints[0]);
      this.scrollBar.drawRoundedRect(0, 0, this.scrollBarWidth, this.scrollBarHeight, this.scrollBarRadius);
      this.scrollBar.endFill();

      this._background = resourceManager.get('helpBackground:GameBackground');
      this._background.setHueToPerc(0);

      this.closeButton = resourceManager.get('helpPageScrollContainer:helpPageScroll:closeButton');
      this.closeButton.interactive = true;
      this.closeButton.mousedown = () => this.close();
      this.closeButton.touchstart = () => this.close();

      this.areaDown = false;
      this.barDown = false;
      this.barOver = false;
      this.lastPos = null;
      this.lastDiffence = null;
      this.scrollAnim = null;

      const self = this;

      this.touchArea = resourceManager.get('helpPageScrollContainer:helpPageScroll:touchArea');
      this.touchArea.beginFill(0xffffff);
      this.touchArea.lineStyle(0, 0xffffff);
      this.touchArea.drawRect(0, 0, 1, 1);
      this.touchArea.scale.x = 1260;
      this.touchArea.scale.y = 700;
      this.touchArea.x = 10;
      this.touchArea.y = 10;
      this.touchArea.interactive = true;
      this.touchArea.alpha = 0;

      this.touchArea.on('mouseout', function (e) {
        self.areaMouseUp(e);
      });

      this.touchArea.mousemove = (e) => this.areaMouseMove(e);
      this.touchArea.mousedown = (e) => this.areaMouseDown(e);
      this.touchArea.mouseup = (e) => this.areaMouseUp(e);
      this.touchArea.mouseupoutside = (e) => this.areaMouseUp(e);
      this.touchArea.touchmove = (e) => this.areaMouseMove(e);
      this.touchArea.touchstart = (e) => this.areaMouseDown(e);
      this.touchArea.touchend = (e) => this.areaMouseUp(e);
      this.touchArea.touchendoutside = (e) => this.areaMouseUp(e);

      this.scrollBarContainer = resourceManager.get('helpPageScrollContainer:helpPageScroll:scrollBarContainer');

      this.scrollBarContainer.interactive = true;
      this.scrollBarContainer.touchmove = (e) => this.barMouseMove(e);
      this.scrollBarContainer.mousemove = (e) => this.barMouseMove(e);
      this.scrollBarContainer.mousedown = (e) => this.barMouseDown(e);
      this.scrollBarContainer.mouseup = (e) => this.barMouseUp(e);
      this.scrollBarContainer.mouseupoutside = (e) => this.barMouseUp(e);
      this.scrollBarContainer.touchstart = (e) => this.barMouseDown(e);
      this.scrollBarContainer.touchend = (e) => this.barMouseUp(e);
      this.scrollBarContainer.touchendoutside = (e) => this.barMouseUp(e);

      this.scrollBarContainer.on('mouseover', function (e) {
        self.barOver = true;

        if (!self.barDown) {
          self.scrollBar.tint = self.tints[1];
        }
      });
      this.scrollBarContainer.on('mouseout', function (e) {
        self.barOver = false;

        if (!self.barDown) {
          self.scrollBar.tint = self.tints[0];
        }
      });

      //PIXI v4 doesn't seem to support mouse wheel so using event listener
      addEventListener('wheel', (e) => this.areaMouseWheel(e));

      Reflex.registerEventHandler('orientationChange', this.orientationChange.bind(this));

      messageBus.subscribe('game:modal', this.onModal.bind(this));

      this.orientationChange();
    }

    onGameConfigEvent(task) {
      // Set the pot multipliers penny values
      // this._potMultiplierMini = task.data.potData.mini / 10;
      // this._potMultiplierMinor = task.data.potData.minor / 10;
      // this._potMultiplierMajor = task.data.potData.major / 10;
      // this._potMultiplierMega = task.data.potData.mega / 10;
    }

    barMouseDown(e) {
      const { originalEvent } = e.data;
      const clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;

      if (this.scrollAnim) {
        this.scrollAnim.kill();
      }

      this.lastPos = {
        y: clientY,
      };

      this.scrollBar.tint = this.tints[2];
      this.barDown = true;
    }

    barMouseUp(e) {
      this.scrollBar.tint = this.barOver ? this.tints[1] : this.tints[0];
      this.barDown = false;
      this.areaDown = false;
    }

    barMouseMove(e) {
      const { originalEvent } = e.data;
      var clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;

      if (!clientY || !this.lastPos) return;

      if (this.barDown) {
        this.lastDiffence = clientY - this.lastPos.y;
        this.lastPos.y = clientY;

        const yPos = this.scrollBarContainer.y;
        const min = this.scrollBarTotalHeight;
        const max = gdk.getScreenHeight() - yPos;
        const pos = (min / max) * (clientY - yPos);

        this.scrollBar.y = pos;

        this.barCap();
        this.scrollProgress = this.scrollBar.y / this.maxScrollBar;
        this.setAreaProgress();
      }
    }

    orientationChange() {
      if (systemData.isLandscape) {
        this.mask.width = this.scrollMax;
        this.mask.height = this.scrollMin;

        this.touchArea.scale.x = 1260;
        this.touchArea.scale.y = 700;
        this.touchArea.x = 10;
        this.touchArea.y = 10;
      } else {
        this.mask.width = this.scrollMin;
        this.mask.height = this.scrollMax;

        this.touchArea.scale.x = 700;
        this.touchArea.scale.y = 1260;
        this.touchArea.x = 10;
        this.touchArea.y = 10;
      }

      for (let i = 0; i < this.itemContainers.length; i++) {
        this.itemContainers[i].y = this.itemPositions[i];
      }

      this.setAreaProgress();
      this.scrollDistanceCap();
    }

    open() {
      if (!this._initialised) {
        this._initialised = true;
        this.initialise();
      }

      this.startAnimations();

      this.visible = true;

      messageBus.post('game:modal', {
        reason: 'Options menu open',
      });

      this.scrollProgress = 0;
      this.setAreaProgress();
      this.setBarProgress();

      this._background.visible = true;
      this._background.setHueToPerc(this.scrollProgress);

      this.updateFairnessText();
      this.updatePrizePotText();
    }

    updatePrizePotText() {
      let persistenValues = gameController.getPersistentValues(gameController.getCurrentModeStake(), true);

      let multi = (gameController.getCurrentModeStake(true) / 100) * 5;
      const potValueMini = persistenValues.miniJackpotLevel * multi;
      const potValueMinor = persistenValues.minorJackpotLevel * multi;
      const potValueMaxi = persistenValues.maxiJackpotLevel * multi;
      const potValueMajor = persistenValues.majorJackpotLevel * multi;
      const potValuePorker = persistenValues.porkerJackpotLevel * multi;
      const potValueMega = persistenValues.megaJackpotLevel * multi;

      const megaName = `helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:potprizes:potsContainer:megaPotSprite:cashpotText`;
      resourceManager.get(megaName).setTranslationParameters(gdk.formatCurrency(potValueMega, false));
      const porkerName = `helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:potprizes:potsContainer:porkerPotSprite:cashpotText`;
      resourceManager.get(porkerName).setTranslationParameters(gdk.formatCurrency(potValuePorker, false));
      const majorName = `helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:potprizes:potsContainer:majorPotSprite:cashpotText`;
      resourceManager.get(majorName).setTranslationParameters(gdk.formatCurrency(potValueMajor, false));
      const maxiName = `helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:potprizes:potsContainer:maxiPotSprite:cashpotText`;
      resourceManager.get(maxiName).setTranslationParameters(gdk.formatCurrency(potValueMaxi, false));
      const minorName = `helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:potprizes:potsContainer:minorPotSprite:cashpotText`;
      resourceManager.get(minorName).setTranslationParameters(gdk.formatCurrency(potValueMinor, false));
      const miniName = `helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:potprizes:potsContainer:miniPotSprite:cashpotText`;
      resourceManager.get(miniName).setTranslationParameters(gdk.formatCurrency(potValueMini, false));
    }

    updateFairnessText() {
      this._fairnessText = resourceManager.get(
        'helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:rtpMaxWin:rtp'
      );

      var stakeController = resourceManager.getController('stakeController');
      var stake = stakeController.CurrentStake;
      var stakeIndex = stakeController.SelectedStakeIndex;
      var baseStake = stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
      var rtp = gameData.slotConfig.RTP[stakeIndex] * 100;

      this._fairnessText.setTranslationParameters(
        gdk.formatCurrency(stake),
        gdk.formatCurrency(baseStake * gameData.maxExposure),
        rtp.toFixed(1)
      );

      const versionText = resourceManager.get('helpPageScrollContainer:helpPageScroll:versionText');
      const versionStr =
        'v' +
        gameData.gameVersionMajor +
        '.' +
        gameData.gameVersionMinor +
        '.' +
        gameData.gameVersionBugFix +
        ' - ' +
        gameData.gameMathsVersion +
        '\n(' +
        gameData.gameReleaseDate +
        ')';
      versionText.setText(versionStr);
    }

    close() {
      this.visible = false;

      this.stopAnimations();

      resourceManager.get('helpBackground:GameBackground').visible = false;

      messageBus.post('game:modal', {});

      soundManager.play('buttonPressed');
    }

    setAreaProgress() {
      this.scrollContainer.y = -this.allContentHeight * this.scrollProgress;

      this.animateBackground();
    }

    setBarProgress() {
      if (this.scrollContainer.y == 0) {
        this.scrollProgress = 0;
      } else {
        this.scrollProgress = -this.scrollContainer.y / this.allContentHeight;
      }

      this.animateBackground();

      this.scrollBar.y = this.scrollProgress * (this.scrollBarTotalHeight - this.scrollBarHeight);
    }

    animateBackground() {
      this._background.setHueToPerc(this.scrollProgress);
      // this.backgroundFreeSpins.alpha = this.scrollProgress;
    }

    areaMouseWheel(e) {
      if (this.scrollContainer.y <= 0 && -this.scrollContainer.y <= this.allContentHeight) {
        this.scrollContainer.y -= e.deltaY;
      }

      this.scrollDistanceCap();
    }

    barCap() {
      this.scrollBar.y = Math.min(Math.max(this.scrollBar.y, 0), this.maxScrollBar);
    }

    scrollDistanceCap() {
      this.scrollContainer.y = Math.min(Math.max(this.scrollContainer.y, -this.allContentHeight), 0);

      this.setBarProgress();
    }

    areaMouseMove(e) {
      const { originalEvent } = e.data;
      var clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;

      if (!clientY || !this.lastPos) return;

      if (this.areaDown && !this.barDown) {
        this.lastDiffence = clientY - this.lastPos.y;
        this.lastPos.y = clientY;

        if (this.scrollContainer.y <= 0 && -this.scrollContainer.y <= this.allContentHeight) {
          this.scrollContainer.y += this.lastDiffence;
        }

        this.scrollDistanceCap();
      }
    }

    areaMouseDown(e) {
      const { originalEvent } = e.data;
      const clientY = !originalEvent.touches ? originalEvent.clientY : originalEvent.touches[0].clientY;
      this.areaDown = true;

      if (this.scrollAnim) {
        this.scrollAnim.kill();
      }

      this.lastPos = {
        y: clientY,
      };
    }

    areaMouseUp() {
      const minSpeed = 5;

      const duration = Math.abs(this.lastDiffence / 50);

      const gotoY = Math.min(Math.max(this.scrollContainer.y + this.lastDiffence * 20, -this.allContentHeight), 0);

      if (this.lastDiffence != null) {
        if (Math.abs(this.lastDiffence) > minSpeed) {
          this.scrollAnim = gsap.to(this.scrollContainer, {
            duration,
            y: gotoY,
            ease: 'power2.out',
            onUpdate: () => {
              this.scrollDistanceCap();
            },
          });
        }
      }

      this.areaDown = false;

      if (!this.barOver) {
        this.lastPos = null;
        this.lastDiffence = null;
        this.scrollBar.tint = this.tints[0];
        this.barDown = false;
      }
    }

    addItems(container, defaultGapBetweenChildren) {
      const items = container.children;
      this.amountRemove = 0;

      if (items.length === 0) return;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.Props) {
          const condition = item.Props.condition;
          const customBuffer = item.Props.customBuffer;
          const nextGap = typeof item.Props.nextGap === 'number' ? item.Props.nextGap : defaultGapBetweenChildren;

          let height = Math.ceil(item.height);

          if (customBuffer) {
            height += customBuffer;
            this.amountRemove += customBuffer;
          } else {
            // nextGap is + or - number of pixels to push the next item down
            height += nextGap;
            this.amountRemove += nextGap;
          }

          this.addItem(condition, item, height);
        }
      }
    }

    addItem(condition, item, size) {
      if (this.checkCondition(condition)) {
        this.itemPositions.push(this.allContentHeight);
        this.itemContainers.push(item);
        this.allContentHeight += size;
      } else {
        item.visible = false;
      }
    }

    checkCondition(condition) {
      if (condition === undefined) {
        return true;
      }

      return eval(condition);
    }

    onModal(data) {
      if (this.visible) {
        if (data.reason === undefined) {
          messageBus.post('game:modal', {
            reason: 'Options menu open',
          });
        }
      }
    }
  }

  let scrollContainerCreator = function (json) {
    return new ScrollContainer();
  };

  resourceManager.registerObjectType(
    'scrollContainer',
    scrollContainerCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
